import type { IFlowsContent } from './types';

/**
 * This is the data that will populate the Flow Builder for each flow
 */
const abandonedCartVipCustomerEmailNodes = [{
  id: '1',
  type: 'custom',
  position: { x: 0, y: 50 },
  data: {
    title: 'Trigger',
    icon: 'LightningOutline',
    text: 'When someone Added to Cart',
  },
},
{
  id: '2',
  type: 'custom',
  position: { x: 50, y: 200 },
  data: { 
    title: 'Wait 3 hours',
    icon: 'ClockOutline',
    hasMenu: true,
  },
},
{
  id: '3',
  type: 'custom',
  position: { x: 50, y: 310 },
  data: {
    title: 'Reminder Email 1',
    icon: 'MailOutline',
    showInformation: true,
  },
},
{
  id: '4',
  type: 'custom',
  position: { x: 50, y: 420 },
  data: {
    title: 'Wait 17 hours',
    icon: 'ClockOutline',
    hasMenu: true,
  },
},
{
  id: '5',
  type: 'custom',
  position: { x: 50, y: 530 },
  data: {
    title: 'Reminder Email 2',
    icon: 'MailOutline',
    showInformation: true,
  },
},
{
  id: '6',
  type: 'custom',
  position: { x: 148, y: 635 },
  data: { text: 'END', type: 'end' },
}];

const abandonedCartVipCustomerEmailEdges = [
  { id: 'e1-2', source: '1', target: '2', type: 'custom' },
  { id: 'e2-3', source: '2', target: '3', type: 'custom' },
  { id: 'e3-4', source: '3', target: '4', type: 'custom' },
  { id: 'e4-5', source: '4', target: '5', type: 'custom' },
  { id: 'e5-6', source: '5', target: '6', type: 'custom' },
];


const multiChannelBrowseAbandonmentNodes = [
  {
    id: '1',
    type: 'custom',
    position: { x: 0, y: 50 },
    data: { 
      title: 'Trigger',
      icon: 'LightningOutline',
      text: 'When someone Viewed Product',
    },
  },
  {
    id: '2',
    type: 'custom',
    position: { x: 50, y: 210 },
    data: { 
      title: 'Wait 1 day',
      icon: 'ClockOutline',
      hasMenu: true,
    },
  },
  {
    id: '3',
    type: 'custom',
    position: { x: 0, y: 330 },
    data: { 
      title: 'Conditional split',
      icon: 'BranchOtherOutline',
      text: 'Has subscribed to SMS Marketing equals...',
      hasMenu: true,
    },
  },
  {
    id: 'yes',
    type: 'custom',
    position: { x: -50, y: 490 },
    data: { 
      text: 'YES',
      type: 'yes',
    },
  },
  {
    id: 'no',
    type: 'custom',
    position: { x: 350, y: 490 },
    data: { 
      text: 'NO',
      type: 'no',
    },
  },
  {
    id: 'sms',
    type: 'custom',
    position: { x: -150, y: 560 },
    data: {
      title: 'Reminder SMS',
      icon: 'MessageOutline',
      showInformation: true,
    },
  },
  {
    id: 'email',
    type: 'custom',
    position: { x: 253, y: 560 },
    data: {
      title: 'Reminder Email',
      icon: 'MailOutline',
      showInformation: true,
    },
  },
  {
    id: 'end1',
    type: 'custom',
    position: { x: -53, y: 670 },
    data: { 
      text: 'END',
      type: 'end',
    },
  },
  {
    id: 'end2',
    type: 'custom',
    position: { x: 350, y: 670 },
    data: { 
      text: 'END',
      type: 'end',
    },
  },
];
const multiChannelBrowseAbandonmentEdges = [
  { id: 'e1-2', source: '1', target: '2', type: 'custom' },
  { id: 'e2-3', source: '2', target: '3', type: 'custom' },
  { id: 'e3-yes', source: '3', target: 'yes', type: 'custom' },
  { id: 'e3-no', source: '3', target: 'no', type: 'custom' },
  { id: 'eno-email', source: 'no', target: 'email', type: 'custom' },
  { id: 'eyes-sms', source: 'yes', target: 'sms', type: 'custom' },
  { id: 'eemail-end2', source: 'email', target: 'end2', type: 'custom' },
  { id: 'esms-end1', source: 'sms', target: 'end1', type: 'custom' },
];

const multiChannelProductRecommendationNodes = [
  {
    id: '1',
    type: 'custom',
    position: { x: 0, y: 50 },
    data: {
      title: 'Trigger',
      icon: 'LightningOutline',
      text: 'When someone Placed Order',
    },
  },
  {
    id: '2',
    type: 'custom',
    position: { x: 50, y: 200 },
    data: {
      title: 'Thank You Email',
      icon: 'MailOutline',
      showInformation: true,
    },
  },
  {
    id: '3',
    type: 'custom',
    position: { x: 50, y: 310 },
    data: { 
      title: 'Wait 2 Day',
      icon: 'ClockOutline',
      hasMenu: true,
    },
  },
  {
    id: '4',
    type: 'custom',
    position: { x: 50, y: 420 },
    data: {
      title: 'Recommendation Email 1',
      icon: 'MailOutline',
      showInformation: true,
    },
  },
  {
    id: '5',
    type: 'custom',
    position: { x: 50, y: 530 },
    data: {
      title: 'Wait 2 Day',
      icon: 'ClockOutline',
      hasMenu: true,
    },
  },
  {
    id: '6',
    type: 'custom',
    position: { x: 0, y: 640 },
    data: { 
      title: 'Conditional split',
      icon: 'BranchOtherOutline',
      text: 'Has subscribed to SMS Marketing equals...',
      hasMenu: true,
    },
  },
  {
    id: 'yes',
    type: 'custom',
    position: { x: -50, y: 790 },
    data: { 
      text: 'YES',
      type: 'yes',
    },
  },
  {
    id: 'no',
    type: 'custom',
    position: { x: 350, y: 790 },
    data: { 
      text: 'NO',
      type: 'no',
    },
  },
  {
    id: 'sms',
    type: 'custom',
    position: { x: -150, y: 860 },
    data: {
      title: 'Recommendation SMS',
      icon: 'MessageOutline',
      showInformation: true,
    },
  },
  {
    id: 'email',
    type: 'custom',
    position: { x: 253, y: 860 },
    data: {
      title: 'Recommendation Email 2',
      icon: 'MailOutline',
      showInformation: true,
    },
  },
  {
    id: 'end1',
    type: 'custom',
    position: { x: -53, y: 970 },
    data: { 
      text: 'END',
      type: 'end',
    },
  },
  {
    id: 'end2',
    type: 'custom',
    position: { x: 350, y: 970 },
    data: { 
      text: 'END',
      type: 'end',
    },
  },
];
const multiChannelProductRecommendationEdges = [
  { id: 'e1-2', source: '1', target: '2', type: 'custom' },
  { id: 'e2-3', source: '2', target: '3', type: 'custom' },
  { id: 'e3-4', source: '3', target: '4', type: 'custom' },
  { id: 'e4-5', source: '4', target: '5', type: 'custom' },
  { id: 'e5-6', source: '5', target: '6', type: 'custom' },
  { id: 'e6-yes', source: '6', target: 'yes', type: 'custom' },
  { id: 'e6-no', source: '6', target: 'no', type: 'custom' },
  { id: 'eno-email', source: 'no', target: 'email', type: 'custom' },
  { id: 'eyes-sms', source: 'yes', target: 'sms', type: 'custom' },
  { id: 'eemail-end2', source: 'email', target: 'end2', type: 'custom' },
  { id: 'esms-end1', source: 'sms', target: 'end1', type: 'custom' },
];

export const nodes = {
  abandonedCartVipCustomerEmail: abandonedCartVipCustomerEmailNodes,
  multiChannelBrowseAbandonment: multiChannelBrowseAbandonmentNodes,
  multiChannelProductRecommendation: multiChannelProductRecommendationNodes,
};

export const edges = {
  abandonedCartVipCustomerEmail: abandonedCartVipCustomerEmailEdges,
  multiChannelBrowseAbandonment: multiChannelBrowseAbandonmentEdges,
  multiChannelProductRecommendation: multiChannelProductRecommendationEdges,
};

/**
 * This is the content that will populate the Flow Form for each flow
 */

const abandonedCartVipCustomerEmailForm = {
  name: 'Abandonded cart VIP customer email flow',
  prompt: 'When someone in my VIP segment abandons a cart valued over $100, send two emails with a 3 and 17 hour delay reminding them to purchase',
  conclusion: 'Once Flows AI builds your flow structure, you can create or edit your Reminder Emails and set your flow live. Your emails will be sent out automatically based on the logic in your flow.',
};

const multiChannelBrowseAbandonmentForm = {
  name: 'Multi-channel browse abandonment flow',
  prompt: 'When someone views a product on my website and does not buy, send them an SMS if they are subscribed, otherwise send them an email',
  conclusion: 'Once Flows AI builds your flow structure, you can create or edit your SMS and email reminders and set your flow live. An SMS or email will be sent out automatically based on the logic in your flow.',
};

const multiChannelProductRecommendationForm = {
  name: 'Multi-channel product recommendation flow',
  prompt: 'When a first-time customer makes a purchase, thank them and then follow up with more product recommendations, send them an SMS if they are subscribed, otherwise send them an email',
  conclusion: 'Once Flows AI builds your flow structure, you can create or edit your Thank You Email and Recommendation Email and SMS, and set your flow live. Your emails and texts will be sent out automatically based on the logic in your flow.',
};

export const flows: IFlowsContent = {
  abandonedCartVipCustomerEmail: abandonedCartVipCustomerEmailForm,
  multiChannelBrowseAbandonment: multiChannelBrowseAbandonmentForm,
  multiChannelProductRecommendation: multiChannelProductRecommendationForm,
};
